import { render, staticRenderFns } from "./rejectDialog.vue?vue&type=template&id=71241626&scoped=true"
import script from "./rejectDialog.vue?vue&type=script&lang=js"
export * from "./rejectDialog.vue?vue&type=script&lang=js"
import style0 from "./rejectDialog.vue?vue&type=style&index=0&id=71241626&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71241626",
  null
  
)

export default component.exports